var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"person",style:(_vm.position)},[_c('img',{attrs:{"src":require("../assets/pikachu-female.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }